import { useState } from 'react';

import { Button, Dialog, Textarea } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { useTuChoiModule } from '../hooks/useQuanLyModule';
import { LY_DO_TU_CHOI_TOI_DA, lyDoTuChoiHopLe } from '../nghiep-vu/thao-tac';
import type { ModuleVersion } from '../types';
import { LoiTrongHop } from './LoiTrongHop';

/** Phần của mutation từ chối mà hộp dùng; mỗi kênh (nền tảng, tổ chức) truyền mutation của mình. */
interface TuChoiModule {
  mutate: (bien: { code: string; version: string; reason: string }, tuyChon?: { onSuccess?: () => void }) => void;
  reset: () => void;
  isPending: boolean;
  isError: boolean;
  error: unknown;
}

/**
 * Hộp từ chối một phiên bản đang `IN_REVIEW`. Lý do bắt buộc: người nộp đọc
 * đúng câu này để sửa và nộp lại (ADR-0046 mục 4, `review_note`).
 */
export function HopTuChoiModule({
  open,
  phienBan,
  onClose,
  onXong,
  tuChoi: tuChoiNgoai,
}: {
  open: boolean;
  phienBan: ModuleVersion | null;
  onClose: () => void;
  onXong?: () => void;
  /** Mutation từ chối của kênh khác: cổng tenant (ADR-0115) truyền vào; bỏ trống là kênh Platform Admin. */
  tuChoi?: TuChoiModule;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  const [lyDo, setLyDo] = useState('');
  const tuChoiNenTang = useTuChoiModule();
  const tuChoi = tuChoiNgoai ?? tuChoiNenTang;

  const dong = () => {
    onClose();
    setTimeout(() => {
      setLyDo('');
      tuChoi.reset();
    }, 200);
  };

  const hopLe = lyDoTuChoiHopLe(lyDo);

  return (
    <Dialog
      open={open}
      onClose={dong}
      title={t('quanLyModule.tuChoi.tieuDe', { phienBan: phienBan?.version ?? '' })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="outline" size="md" onClick={dong}>
            {t('chung.huy')}
          </Button>
          <Button
            variant="primary"
            size="md"
            loading={tuChoi.isPending}
            disabled={!hopLe || !phienBan}
            onClick={() =>
              phienBan &&
              tuChoi.mutate(
                { code: phienBan.code, version: phienBan.version, reason: lyDo.trim() },
                { onSuccess: () => { dong(); onXong?.(); } },
              )
            }
          >
            {t('quanLyModule.tuChoi.nut')}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">{t('quanLyModule.tuChoi.mo')}</p>
        <Textarea
          rows={4}
          maxLength={LY_DO_TU_CHOI_TOI_DA}
          placeholder={t('quanLyModule.tuChoi.oNhap')}
          aria-label={t('quanLyModule.tuChoi.oNhap')}
          value={lyDo}
          onChange={(e) => setLyDo(e.target.value)}
        />
        {tuChoi.isError && <LoiTrongHop>{dichLoi(tuChoi.error)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
